import React from 'react';
import { Viewport } from '../../components/utils';
import NotebookLayoutNS from './NotSmall';
import NotebookLayoutS from './Small';

const NotebookLayout: React.FC = ({ children }) => (
  <Viewport
    small={<NotebookLayoutS children={children} />}
    notSmall={<NotebookLayoutNS children={children} />}
  />
);

export default NotebookLayout;
